import React from "react";

const FaceScan = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-face-scan"
      data-name="icon-face-scan"
      viewBox="0 0 24 24"
      width={_width}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path fill="none" d="M3 8V5a2 2 0 0 1 2-2h3" />
      <path fill="none" d="M16 3h3a2 2 0 0 1 2 2v3" />
      <path fill="none" d="M21 16v3a2 2 0 0 1-2 2h-3" />
      <path fill="none" d="M8 21H5a2 2 0 0 1-2-2v-3" />
      <path fill="none" d="M9 9v1" />
      <path fill="none" d="M15 9v1" />
      <path fill="none" d="M12 9v4h-1" />
      <path fill="none" d="M9 16c1.7 1.3 4.3 1.3 6 0" />
    </svg>
  );
};

export default FaceScan;
